/**
 *
 * @author
 * @company Erillam Healthcare
 * @version 1.0
 *
 */

import ServicePath from "@/core/ServicePath";
import { MainRequest } from "@/core/request";
import axios from "axios";

export default class ParameterRequest extends MainRequest {
  static addParameter(data) {
    return this.postSEC(ServicePath.PARAMETER_ADD, data);
  }

  static listAllParameter() {
    return this.getSEC(ServicePath.PARAMETER_LIST_ALL);
  }

  static getParameter(data) {
    return this.postSEC(ServicePath.PARAMETER_GET, data);
  }

  static updateParameter(data) {
    return this.postSEC(ServicePath.PARAMETER_UPDATE, data);
  }

  static deleteParameter(data) {
    return this.postSEC(ServicePath.PARAMETER_DELETE, data);
  }

  static deleteReferenceValue(data) {
    return this.postSEC(ServicePath.REFERENCE_VALUE_DELETE, data);
  }
  
  static deleteAliasValue(data) {
    return this.postSEC(ServicePath.ALIAS_VALUE_DELETE, data);
  }

  static deleteReferenceResult(data) {
    return this.postSEC(ServicePath.REFERENCE_RESULT_DELETE, data);
  }
}
